import { DatePicker, Button, Space, Image, message } from 'antd'
import { useState, useEffect } from 'react'
import QueryFormComponent from "../components/queryFormComponent";
import TableComponent from "../components/tableComponent";
import ModalComponent from "./components/modalComponent";
import AuthComponent from '../../../components/AuthComponent';
import service from "../../../@services";
import DeleteComponent from "../components/deleteComponent";


const { RangePicker } = DatePicker

const Advertisement = () => {

  const [modalVisible, setModalVisible] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [formVal, setFormVal] = useState({})
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [deleteFormVal, setDeleteFormVal] = useState({})
  const [modalData, setModalData] = useState({})
  const [pageSetting, setPageSetting] = useState({
    pageIndex: 1,
    pageSize: 20
  })
  const [jumpType, setJumpType] = useState([
    {
      label: '无跳转',
      value: 'NO',
    },
    {
      label: '内链',
      value: 'CURRENT',
    },
    {
      label: '外链',
      value: 'LINK',
    },
    {
      label: '小程序',
      value: 'CUSTOM',
    },
    {
      label: '分类',
      value: 'CATEGORY',
    },
    {
      label: '商品',
      value: 'PRODUCT',
    }, {
      label: "专区",
      value: "ZONE"
    }
  ])

  // 查询表单
  const fields = [
    {
      label: '名称',
      name: 'title',
      placeholder: '请输入'
    },
    {
      label: '更新人',
      name: 'operName',
      placeholder: '请输入'
    },
    {
      label: '更新时间',
      name: 'operTime',
      component: (
        <RangePicker
          showTime
          allowClear
          placeholder={['请选择开始时间', '请选择结束时间']}
        />
      )
    }
  ]
  // 表格头
  const columns = [
    {
      title: '排序',
      dataIndex: 'sort',
      key: 'sort',
      align: 'center'
    },
    {
      title: '图片',
      dataIndex: 'imageUrl',
      key: 'imageUrl',
      align: 'center',
      render: (url) => (
        <Image width={100} src={url} />
      )
    },
    {
      title: '名称',
      dataIndex: 'title',
      key: 'title',
      align: 'center'
    },
    {
      title: '链接类型',
      dataIndex: 'hrefType',
      key: 'hrefType',
      align: 'center',
      render: (row) => {
        return jumpType.filter(item => item.value === row)[0].label
      }
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (statu) => {
        return statu == 1 ? '启用' : '停用'
      }
    },
    {
      title: '更新时间',
      dataIndex: 'operTime',
      key: 'operTime',
      align: 'center'
    },
    {
      title: '更新人',
      dataIndex: 'operName',
      key: 'operName',
      align: 'center'
    },
    {
      title: '操作',
      align: 'center',
      render: (row) => (
        <Space>
          <AuthComponent authKey="/mallPageBanner/list">
            <Button
              type="link"
              onClick={() => handleRecommend('edit', row)}
            >编辑</Button>
            <Button
              type="link"
              onClick={() => handleRecommend('delete', row)}
            >删除</Button>
          </AuthComponent>
        </Space>
      )
    }
  ]
  // 时间格式化
  const format = (val, formatStr = 'YYYY-MM-DD HH:mm:ss') => {
    if (!val) return {}
    val.operStartTime = val.operTime ? val.operTime[0].format(formatStr) : null
    val.operEndTime = val.operTime ? val.operTime[1].format(formatStr) : null
    return { ...val }
  }
  // 列表请求
  const getList = () => {
    setLoading(true)
    const params = Object.assign({}, formVal, pageSetting, {
      moduleCode: 'grideMenu'
    })
    service.mallManagement.getListAdvertisement(params).then(res => {
      setTotal(res.recordCount)
      setList(res.result)
    }).catch(err => console.log(err)).finally(() => {
      setLoading(false)
    })
  }
  // 查询
  const searchFormFn = (val) => {
    if (val.operTime && val.operTime.length > 0) {
      let formatVal = format(val)
      setFormVal({ ...formatVal })
    } else {
      setFormVal({ ...val })
    }
    setPageSetting({
      pageIndex: 1,
      pageSize: 20
    })
  }
  // 翻页
  const changePage = (val) => {
    setPageSetting(val)
  }
  // 操作合集
  const handleRecommend = (type, val) => {
    if (type === 'delete') {
      // 删除
      setDeleteFormVal(val)
      setDeleteVisible(true)
    } else if (type === 'edit') {
      // 打开编辑
      service.mallManagement.getDetailAdvertisement(val.id).then(res => {
        if (res.imageUrl) res.url = res.imageUrl
        if (res.hrefType === 'CATEGORY') res.hrefUrl.split(',')
        if (res.hrefType === 'PRODUCT') {
          res.productDetail = JSON.parse(res.hrefData)
          res.name = res.productDetail.name
        }
        setModalData(res)
      }).catch(err => console.log(err))
      setModalTitle('编辑')
      setModalVisible(true)
    } else {
      // 打开新增
      setModalTitle('新增')
      setModalVisible(true)
    }
  }
  // 关闭弹窗
  const closeModal = () => setModalVisible(false)
  // 表单提交
  const submitModal = (val) => {
    console.log(modalTitle, '广告 submitModal', val);
    if (Array.isArray(val.hrefData)) {
      val.echoData = '/erp-mall/category?cid=' + val.hrefData.toString()
      val.hrefData = val.hrefData.toString()
    } else if (val.hrefType === "PRODUCT") {
      val.echoData = '/product/erp/' + val.skuForStoreId
      val.hrefData = JSON.stringify({
        productInfo: val.productInfo,
        storeId: val.storeId,
        name: val.name
      })
    } else if (val.hrefType === 'ZONE') {
      val.echoData = '/erp-mall/mall-zone/' + val.hrefData
    } else {
      val.echoData = val.hrefData
    }
    const subData = {
      hrefData: val.hrefData,
      hrefType: val.hrefType,
      hrefUrl: val.echoData,
      imageUrl: val.imageUrl,
      sort: parseInt(val.sort),
      status: parseInt(val.status),
      title: val.title,
      moduleCode: 'grideMenu'
    }
    if (modalTitle === '新增') {
      service.mallManagement.addAdvertisement(subData).then(res => {
        message.success('新增成功')
        setModalVisible(false)
        getList()
      }).catch(err => console.log(err))
    } else {
      subData.id = val.id
      service.mallManagement.editAdvertisement(subData).then(res => {
        message.success('编辑成功')
        setModalVisible(false)
        getList()
      }).catch(err => console.log(err))
    }
  }
  // 删除
  const deleteFn = (id) => {
    service.mallManagement.deleteAdvertisement(id).then(res => {
      message.success('删除成功')
      setDeleteVisible(false)
      getList()
    }).catch(err => console.log(err))
  }

  useEffect(() => {
    getList()
  }, [pageSetting])

  return (
    <div className="home-mall">
      <QueryFormComponent
        name="homeMall"
        fields={fields}
        authKey={{ search: '/mallPageBanner/list' }}
        onSearch={searchFormFn}
      />
      <TableComponent
        loading={loading}
        columns={columns}
        btnName="新增"
        page={pageSetting}
        total={total}
        list={list}
        authKey={{ search: '/mallPageBanner/list' }}
        addRecommend={() => handleRecommend()}
        changePage={changePage}
      />
      <ModalComponent
        visible={modalVisible}
        title={modalTitle}
        jumpType={jumpType}
        modalData={modalData}
        onCancel={closeModal}
        onOk={submitModal}
      />
      <DeleteComponent
        visible={deleteVisible}
        title="提示"
        onCancel={() => setDeleteVisible(false)}
        onOk={(id) => deleteFn(id)}
        formVal={deleteFormVal}
      />
    </div>
  )
}

export default Advertisement